export enum WIDGET_EVENT_LIST {
    /**
     * @value Display event
     */
    DISPLAY_EVENT = 'WIDGET_EVENT_LIST.DISPLAY_EVENT',
    /**
     * @value Event actions
     */
    EVENT_ACTIONS = 'WIDGET_EVENT_LIST.EVENT_ACTIONS',
    /**
     * @value Only display events from communities the user is following
     * @description The helper displayed after the "Followed communities only" filter to explain what the filter does in the event list widget settings.
     */
    SETTINGS_FOLLOWED_COMMUNITIES_FILTER_HELPER = 'WIDGET_EVENT_LIST.SETTINGS_FOLLOWED_COMMUNITIES_FILTER_HELPER',
    /**
     * @value Show attendees list
     * @description Text used on widget event list settings to set whether the event attendees needs to be displayed.
     */
    SETTINGS_SHOW_ATTENDEES = 'WIDGET_EVENT_LIST.SETTINGS_SHOW_ATTENDEES',
    /**
     * @value Show link
     * @description Text used on widget event list settings to set whether the event location needs to be displayed.
     */
    SETTINGS_SHOW_LINK = 'WIDGET_EVENT_LIST.SETTINGS_SHOW_LINK',
    /**
     * @value Load more button allows users to display more events
     * @description Text used to describe the load more option in widget settings of the widget event list
     */
    SETTINGS_SHOW_LOAD_MORE_HELPER = 'WIDGET_EVENT_LIST.SETTINGS_SHOW_LOAD_MORE_HELPER',
    /**
     * @value Show location
     * @description Text used on widget event list settings to set whether the event location needs to be displayed.
     */
    SETTINGS_SHOW_LOCATION = 'WIDGET_EVENT_LIST.SETTINGS_SHOW_LOCATION',
    /**
     * @value No community event yet
     * @description Text displayed on widget event list empty state title
     */
    WRITER_MODE_EMPTY_STATE_TITLE = 'WIDGET_EVENT_LIST.WRITER_MODE_EMPTY_STATE_TITLE',
    /**
     * @value Community event list settings
     * @description Text displayed as a dialog title on the widget event list writer mode settings
     */
    WRITER_MODE_SETTINGS_TITLE = 'WIDGET_EVENT_LIST.WRITER_MODE_SETTINGS_TITLE',
}
